const CALENDLY_HOSTNAME = "calendly.com";

export const getGaClientIdFromCookie = (cookie = ""): string => {
  const gaCookie = cookie
    .split(";")
    .map((value) => value.trim())
    .find((value) => value.startsWith("_ga="))
    ?.slice(4);

  return gaCookie?.split(".").slice(2).join(".") ?? "";
};

export const buildTrackedCalendlyUrl = (href: string, pagePath: string, cookie = ""): string => {
  try {
    const url = new URL(href);

    if (url.hostname !== CALENDLY_HOSTNAME) {
      return href;
    }

    url.searchParams.set("utm_content", pagePath);
    url.searchParams.set("utm_term", getGaClientIdFromCookie(cookie));

    return url.toString();
  } catch {
    return href;
  }
};
